/** Traductions modal sélection lot (FR / AR) */
export const lotSelectionModalFr = {
  errValidQuantity: 'Veuillez entrer une quantité valide',
  errValidSalePrice: 'Veuillez entrer un prix de vente valide',
  errQtyExceedsAvailable: 'Quantité demandée supérieure à la quantité disponible',
  title: 'Sélectionner le Lot',
  subtitle: 'Choisissez le lot, la quantité et le prix de vente',
  tapToAdd: 'Toucher un lot pour l’ajouter · Entrée = lot surligné · 1–9 = choix rapide',
  singleLotHint: 'Un seul lot — ajustez la quantité si besoin, puis confirmez (Entrée)',
  editPrice: 'Modifier le prix',
  hidePriceEdit: 'Masquer le prix',
  noLotsAvailable: 'Aucun lot disponible pour ce produit',
  lotLabel: 'Lot',
  selectLotPlaceholder: '-- Sélectionner un lot --',
  availableUnit: 'dispo.',
  availableLabel: 'Disponible',
  lotsUnit: 'lots',
  fromLotsCount: 'de {{count}} lots',
  expiryShort: 'Exp',
  sellingPriceLabel: 'Prix de vente',
  purchasePriceLabel: "Prix d'achat",
  purchasePriceShort: 'Achat',
  oldestFirstHint: 'Lots du plus ancien au plus récent (FIFO)',
  pickingMethod: 'Picking : {{method}}',
  quantityLabel: 'Quantité',
  maximumLabel: 'Maximum',
  confirmBtn: 'Confirmer',
  notAvailable: 'N/D'
};

export const lotSelectionModalAr = {
  errValidQuantity: 'يرجى إدخال كمية صحيحة',
  errValidSalePrice: 'يرجى إدخال سعر بيع صحيح',
  errQtyExceedsAvailable: 'الكمية المطلوبة أكبر من الكمية المتاحة',
  title: 'اختيار اللوتات',
  subtitle: 'اختر اللوتات والكمية وسعر البيع',
  tapToAdd: 'المس اللوت للإضافة · Enter للمحدد · 1–9 اختيار سريع',
  singleLotHint: 'لوت واحد فقط — عدّل الكمية إن لزم ثم أكّد (Enter)',
  editPrice: 'تعديل السعر',
  hidePriceEdit: 'إخفاء السعر',
  noLotsAvailable: 'لا توجد لوتات متاحة لهذا المنتج',
  lotLabel: 'اللوتات',
  selectLotPlaceholder: '-- اختر اللوتات --',
  availableUnit: 'متاح',
  availableLabel: 'متاح',
  lotsUnit: 'اللوتات',
  fromLotsCount: 'من {{count}} اللوتات',
  expiryShort: 'انتهاء',
  sellingPriceLabel: 'سعر بيع',
  purchasePriceLabel: 'سعر الشراء',
  purchasePriceShort: 'شراء',
  oldestFirstHint: 'اللوتات من الأقدم إلى الأحدث (FIFO)',
  pickingMethod: 'طريقة الجمع: {{method}}',
  quantityLabel: 'الكمية',
  maximumLabel: 'الحد الأقصى',
  confirmBtn: 'تأكيد',
  notAvailable: 'غير متوفر'
};
